function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.78 79.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.26,1.39C.2,4.94-1.56,15.39,1.54,23.43c1.55,4.01,1.92,6.04,5.02,27.71,1.05,7.36,2.86,14.79,4.87,20,2.77,7.18,3.51,8.29,5.59,8.29h2.39l.72-16c.4-8.8.72-20.05.71-25,0-6.42.57-10.67,2.01-14.84,1.11-3.21,2.3-7.98,2.64-10.59.61-4.57.5-4.83-2.73-6.9-1.85-1.19-4.71-3.06-6.36-4.16C12.86-.42,8.18-.65,5.26,1.39",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.12,4.78c1.81,1.57,4.24,3.36,5.41,3.97,1.93,1.01,2.04,1.56,1.23,5.9-.49,2.63-1.62,6.69-2.51,9.03l-1.62,4.25h-6.15c-5.65,0-6.28-.22-7.75-2.75-.88-1.51-1.92-5.11-2.31-7.99-.58-4.29-.31-6.05,1.45-9.69C6.92,1.21,10.98.31,16.12,4.78",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.46,42.43c-.13,6.6-.31,17.06-.39,23.25-.09,6.19-.54,11.25-1.01,11.25-2.97,0-10.18-30.24-10.15-42.54v-4.04s5.9.04,5.9.04l5.89.04-.24,12",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg33);
export default __webpack_public_path__ + "static/media/33.7a77d74d550ea3a98add880ff0ed4d2c.svg";
export { ForwardRef as ReactComponent };